import React, { Component } from 'react';
import PropTypes from 'prop-types';

import i18n from 'i18n-react';
import Select from 'react-select';

import StorageHandler from 'config/StorageHandler';
import { contentKeys, storageKeys } from 'config/settings.json';

import countryFlags from './countryFlags';

const CountryFlag = ({ flag }) => {
  if (!flag || typeof flag !== 'string') {
    const FallbackFlag = countryFlags['en-US'];
    return <FallbackFlag />;
  }

  if (flag.toLowerCase() === 'global' && countryFlags.global) {
    const FlagComponent = countryFlags.global;
    return <FlagComponent />;
  }

  const [lang, region] = flag.split('-');
  const normalizedFlag = `${lang}-${region || lang.toUpperCase()}`;

  const FlagComponent = countryFlags[normalizedFlag] || countryFlags['en-US'];

  return <FlagComponent />;
};

const changeLanguage = (language) => {
  StorageHandler.removeKeys(contentKeys);
  StorageHandler.remove(storageKeys.progress);
  StorageHandler.save(storageKeys.lang, {
    country: language.label,
    code: language.value,
    langFile: language.langFile,
  });
  window.location.reload();
};

export default class LanguageSelect extends Component {
  constructor(props) {
    super(props);

    this.state = {
      language: [],
      selected: '',
      expand: false,
    };
  }

  componentDidMount() {
    StorageHandler.load(storageKeys.appInfo).then(({ languages }) => {
      const language = languages.map((lan) => ({
        value: lan.code,
        label: lan.country,
        langFile: lan.langFile,
      }));

      this.setState({ language });
    });
    StorageHandler.load(storageKeys.lang).then(({ code, country }) => {
      const activeCountry = { value: code, label: country };
      this.setState({ selected: activeCountry });
    });
  }

  focusHandler() {
    this.setState((prevState) => ({ expand: !prevState.expand }));
  }

  render() {
    const { size, ...selectProps } = this.props;
    const { selected, language, expand } = this.state;

    //  Hide flag if only one language available
    if (language.length <= 1) {
      return null;
    }

    // Context meant for differentiating between current selection and dropdown options
    const formatOptionLabel = ({ value, label }) => {
      const displayLabel =
        typeof label === 'string'
          ? label.replace('United States', 'Global English').replace('Mexico', 'Spanish').replace(/[_]/g, ' ').trim()
          : '';

      const isGlobal = displayLabel.toLowerCase().startsWith('global');
      const flagKey = isGlobal ? 'global' : value;

      return (
        <p className="customOption">
          <CountryFlag flag={flagKey} />
          {displayLabel || 'Error loading languages'}
        </p>
      );
    };

    return (
      <div className="lang__select">
        <Select
          value={selected}
          options={language}
          onChange={changeLanguage}
          formatOptionLabel={formatOptionLabel}
          onFocus={() => this.focusHandler()}
          onBlur={() => this.focusHandler()}
          {...selectProps}
          menuPlacement="top"
          aria-label={i18n.translate('general.selectLanguage')}
        />
      </div>
    );
  }
}

LanguageSelect.propTypes = {
  menuPlacement: PropTypes.string,
  size: PropTypes.number,
};

LanguageSelect.defaultProps = {
  menuPlacement: 'bottom',
  size: 2,
};

CountryFlag.propTypes = {
  flag: PropTypes.string,
};

CountryFlag.defaultProps = {
  flag: null,
};
